// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"e7a76bf5","344":"7d7a478b","537":"13216993"}[chunkId] + ".chunk.js";
};